var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-progress-container"},[_c('ul',{class:_vm.stepProgressClass},_vm._l((_vm.totalStep),function(i){return _c('li',{key:i,class:_vm.stepColor(i)},[_vm._v(_vm._s(_vm.stepText(i)))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }